import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../../Actions/AllAction';
import CustomInput from '../../../../Utility/Components/CustomInput'
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import PhoneNumberWithCountryCode from '../../../../Utility/Components/PhoneNumberWithCountryCode';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import ImageCropContent from '../../../../Utility/Components/ImageCropContent';
import { withNamespaces } from 'react-i18next';
import Utility from '../../../../Utility/Utility';
// import AdminAgentSwitchStaff from '../../../../Utility/Components/AdminAgentSwitchStaff';


function UserAddEditModalContent(props) {
    //======= add action permission ====//
    // Check multiple permissions at once
    const userAddEditPermissions = Utility.hasMultipleActionPermissions(
        'user_and_customer',
        'users',
        ['create', 'edit', 'delete', 'change_status', 'assign_role'],
        props?.userCredentials?.user_details?.user_type || ['admin', 'app_admin']
    );

    return (
        <div className="gridcontainer">
            <div className="modalinnerbody">
                <div className="innerbodydimension">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName={props.t('firstname')}
                                                errorLabel={props.errorFormData.first_name}
                                                name="firstName"
                                                type="text"
                                                value={props.formData.first_name}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'first_name')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName="Last Name"
                                                errorLabel={props.errorFormData.last_name}
                                                name="name"
                                                type="text"
                                                value={props.formData.last_name}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'last_name')}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <ErrorBoundary title="CustomInput Error">
                                            <CustomInput
                                                parentClassName="input_field_inner"
                                                labelName={props.t('Email')}
                                                errorLabel={props.errorFormData.email}
                                                name="email"
                                                type="text"
                                                value={props.formData.email}
                                                labelPresent={true}
                                                onChange={(e) => props.handelChange(e, 'email')}
                                                readOnly={props.editedFlag ? true : false}
                                                requiredStar={false}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input_field_inner_phone'>
                                            <ErrorBoundary title="PhoneInput Error">
                                                <PhoneNumberWithCountryCode
                                                    country={props.phoneNumberCountryCode}
                                                    value={props.formData.contact_number}
                                                    onChange={(e, country) => props.handelChange(e, 'contact_number', country)}
                                                    error={props.errorFormData.contact_number}
                                                    labelShow={true}
                                                    requirStart={true}
                                                    disabled={props.editedFlag ? true : false}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="user_add_img modprofile userprofile_img">
                                    <div className="userProfileImg">
                                        {!props.addProfileImagePreviewShow ?
                                            <label className="custom-file-upload">
                                                <span className="filetext">
                                                    <img src={props.addprofileImageSelected}
                                                    />
                                                </span>
                                                <span className="plusicon">
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                    <input type="file" accept={Utility.acceptFileType()} onChange={props.addInputProfileImageChanged} />
                                                </span>
                                            </label> :
                                            <label className="custom-file-upload">
                                                <img src={props.addprofileImageSelected} />
                                                <span className="plusicon">
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                    <input type="file" accept={Utility.acceptFileType()} onChange={props.addInputProfileImageChanged} />
                                                </span>
                                            </label>}

                                        <div className="col-md-12 errorClass error_div">{props.errorFormData.profile_image}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className='row'>
                            <div className="col-md-4">
                                <div className="dropdowninnerboxContainer">
                                    <label>Organization Name <span>*</span></label>
                                    <ErrorBoundary title="AutosuggestComponent Error">
                                        <AutosuggestComponent
                                            handleOnChange={(e) => props.handelChange(e, 'hotel_name')}
                                            options={props.hotelListData}
                                            selectedValue={props.hotelSelectedValue}
                                            name=''
                                            isMulti={true}
                                            placeholder=""
                                            isDisabled={['admin', 'staff'].includes(props.userCredentials.user_details.user_type) ? true : false}
                                            isSearchable={true}
                                            classNamePrefix="dropdown-default"
                                            menuPosition="fixed"
                                        />
                                    </ErrorBoundary>
                                    <div className="col-md-12 errorClass error_div">{props.errorFormData.hotel_name}</div>
                                </div>
                            </div>
                            {['admin', 'staff'].includes(props.userCredentials.user_details.user_type) &&
                                <div className="col-md-4">
                                    <div className="dropdowninnerboxContainer">
                                        <label>Branch Name <span>*</span></label>
                                        <ErrorBoundary title="AutosuggestComponent Error">
                                            <AutosuggestComponent
                                                handleOnChange={(e) => props.handelChange(e, 'hotel_branch')}
                                                options={props.branchList}
                                                selectedValue={props.branchSelectedValue}
                                                name=''
                                                isMulti={false}
                                                placeholder=""
                                                isSearchable={true}
                                                classNamePrefix="dropdown-default"
                                                isDisabled={props.branchList.length == 1 ? true : false}
                                                menuPosition="fixed"
                                            />
                                        </ErrorBoundary>
                                        <div className="col-md-12 errorClass error_div">{props.errorFormData.hotel_branch}</div>
                                    </div>
                                </div>}
                            {['admin', 'staff'].includes(props.userCredentials.user_details.user_type) && 
                                <div className="col-md-4">
                                    <div className="dropdowninnerboxContainer">
                                        <label>Role <span>*</span></label>
                                        <ErrorBoundary title="AutosuggestComponent Error">
                                            <AutosuggestComponent
                                                handleOnChange={(e) => props.handelChange(e, 'role')}
                                                options={props.roleList}
                                                selectedValue={props.roleSelectedValue}
                                                name=''
                                                isMulti={false}
                                                placeholder=""
                                                isDisabled={props.isDisableRole || !userAddEditPermissions?.assign_role}
                                                isSearchable={true}
                                                classNamePrefix="dropdown-default"
                                                menuPosition="fixed"
                                            />
                                        </ErrorBoundary>
                                        <div className="col-md-12 errorClass error_div">{props.errorFormData.role}</div>
                                    </div>
                                </div>}

                            <div className='col-md-12'>
                                <div className='row'>
                                    {props.hasAdminAndAgent &&
                                        <>
                                            {!props.editedFlag &&
                                                <div className='col-md-4'>
                                                    <div className={['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type) ? "listingPrefaranceBox globallistingPrefaranceBox agentMt0" : "listingPrefaranceBox globallistingPrefaranceBox agentStaffMt0"}>
                                                        <div className='chkBoxPanelList'>
                                                            <label className="chkContainer">
                                                                <input type="checkbox"
                                                                    checked={props.isAlsoAgentAdmin}
                                                                    onChange={(e) => props.setIsAlsoAgentAdmin(e.target.checked)}
                                                                />
                                                                {['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type) ? "Is also branch staff" : "Is also agent staff"}
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {/* {props.isAlsoAgentAdmin &&
                                                <AdminAgentSwitchStaff roleList={props.agentroleList} branchList={props.branchList} handelChange={props.handelChange} agentroleSelectedValue={props.agentroleSelectedValue} agentbranchSelectedValue={props.agentbranchSelectedValue} errorFormData={props.errorFormData} />} */}
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-md-12 text-center topspace">
                    <button type="button" className="modBtnSave" onClick={(e) => props.adminDataSave()}>{!props.editedFlag ? props.t('save') : "Update"}</button>
                    <button type="button" className="modBtnSave cancelbtn" onClick={(e) => props.closeAdminModal()}>Cancel</button>
                </div>
            </div>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={props.imageCropModalFlag}
                    onHide={props.imageCropModalHide}
                    onCancel={props.imageCropModalHide}
                    onSave={props.imageCropDataSave}
                    className="modalcustomizeDialog cropmodalcontentDialog"
                    bodyClassName="cropmodalcontentbody"
                    headerclassName="close_btn_icon"
                    title={props.t('cropimage')}
                    footer={true}
                    closeButton={true}
                    saveButtonLabel={props.t('crop')}
                    saveButtonClassName="delconfirmbtn btn btn-primary"
                    cancelButtonClassName="delcancelbtn btn btn-primary"
                    body={
                        <>
                            <ErrorBoundary title="ModalGlobal Error">
                                <ImageCropContent
                                    onImageLoaded={props.onImageLoaded}
                                    onComplete={props.onCropComplete}
                                    onCropChange={props.onCropChange}
                                    crop={props.crop}
                                    croppedImageUrl={props.croppedImageUrl}
                                    src={props.src}
                                    onCropComplete={props.onCropComplete}
                                    imageCropModalShow={props.imageCropModalShow}
                                    circularCrop={false}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
        </div>
    );
};

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        userGroup: globalState.LoginReducer.userGroup
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(UserAddEditModalContent));
